import request from '@/utils/request'

export function getDetailDocumentRefund(consecutive, branch_id) {
  return request({
    url: 'document/getDetailDocumentRefund/' + consecutive + '/' + branch_id,
    method: 'get'
  });
}

export function getDocumentsInvoice(type, consecutive, nit) {
  return request({
    url: 'document/getDocumentsInvoice/' + type + '/' + consecutive + '/' + nit,
    method: 'get'
  });
}

export function getDocumentClient(nit, branch_id) {
  return request({
    url: 'document/getDocumentClient/' + nit + '/' + branch_id,
    method: 'get'
  });
}

export function saveRefund(data) {
  return request({
    url: 'document/saveRefund',
    method: 'post',
    data
  });
}

export function getDocuments(page_size, currentPage, types_documents, consecutive, date, client) {
  return request({
    url: 'document/getDocuments/' + page_size + '/' + types_documents + '/' + consecutive + '/' + date + '/' + client + '?page=' + currentPage,
    method: 'get',
  });
}

export function anulateDocument(data) {
  return request({
    url: 'document/anulateDocument',
    method: 'post',
    data
  });
}

export function getDocumentTransfer(data) {
  return request({
    url: 'document/getDocumentTransfer',
    method: 'post',
    data
  });
}

export function acceptTransfer(data) {
  return request({
    url: 'document/acceptTransfer',
    method: 'post',
    data
  });
}

export function printTransfer(data) {
  return request({
    url: 'document/printTransfer',
    method: 'post',
    data
  });
}
